import { useEffect } from 'react';

/**
 * Sets the browser-tab title and restores the previous title on unmount — a
 * set-and-forget page would leak its stale title onto the next route.
 * No-op while `title` is undefined, covering pages whose title depends on
 * async data (e.g. broker-detail's broker.name).
 */
export const useDocumentTitle = (title: string | undefined): void => {
  useEffect(() => {
    if (title === undefined) return;
    const previousTitle = document.title;
    document.title = title;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};
